import jaycoLogo from '/lovable-uploads/jayco-logo.svg';
import keystoneLogo from '@/assets/Keystone-Logo-Horizontal-2.png';
import kzrvLogo from '@/assets/KZ-RV-Logo-Horizontal-white.svg';
import thorLogo from '@/assets/Thor-Logo-Horizontal-white.svg';
import tiffinLogo from '@/assets/Tiffin-Logo-Horizontal-2.png';

export interface BrandTheme {
  sidebarHsl: string; // HSL values for CSS variable (no hsl() wrapper)
  primaryHsl: string;
  logo: string;
}

export const brandThemes: Record<string, BrandTheme> = {
  Jayco: {
    sidebarHsl: '212 100% 36%',   // #005eb8
    primaryHsl: '221 83% 53%',     // #3366ff
    logo: jaycoLogo,
  },
  Keystone: {
    sidebarHsl: '0 0% 0%',        // #000000
    primaryHsl: '0 0% 0%',
    logo: keystoneLogo,
  },
  'KZ-RV': {
    sidebarHsl: '72 10% 19%',     // #3E441E
    primaryHsl: '72 10% 19%',
    logo: kzrvLogo,
  },
  Thor: {
    sidebarHsl: '137 26% 33%',    // #406745
    primaryHsl: '137 26% 33%',
    logo: thorLogo,
  },
  Tiffin: {
    sidebarHsl: '0 0% 0%',        // #000000
    primaryHsl: '0 0% 0%',
    logo: tiffinLogo,
  },
};

export const DEFAULT_BRAND = 'Jayco';

export function applyBrandTheme(brandKey: string) {
  const theme = brandThemes[brandKey] || brandThemes[DEFAULT_BRAND];
  const root = document.documentElement;
  root.style.setProperty('--sidebar-background', theme.sidebarHsl);
  root.style.setProperty('--sidebar-header-background', theme.sidebarHsl);
  root.style.setProperty('--sidebar-border', theme.sidebarHsl);
  root.style.setProperty('--primary', theme.primaryHsl);
  root.style.setProperty('--primary-hover', theme.primaryHsl);
}

export function getStoredBrand(): string {
  try {
    return sessionStorage.getItem('selectedBrand') || DEFAULT_BRAND;
  } catch {
    return DEFAULT_BRAND;
  }
}

export function storeSelectedBrand(brandKey: string) {
  sessionStorage.setItem('selectedBrand', brandKey);
}
